import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { __SITE_CONSTANTS__ } from "../constants.js";

onDocumentLoaded(() => {
    const chequeForm = document.querySelector(".cheque-form");

    const getChequeInfo = async (uid) => {
        try {
            const response = await fetch(
                `${__SITE_CONSTANTS__.baseUrl}/api/public/receipt/${uid}`,
                {
                    method: "GET",
                    headers: {
                        accept: "application/json",
                    },
                }
            );

            if (!response.ok) {
                const error = await response.json().catch(() => null);

                if (error?.detail) {
                    iziToast.error({
                        title: error.detail,
                        position: "topRight",
                    });
                }

                return null;
            }

            return await response.json();
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    document.querySelector(".cheque-back")?.addEventListener("click", () => {
        location.reload();
    });

    chequeForm?.addEventListener("submit", async (e) => {
        e.preventDefault();

        const currentForm = e.currentTarget;
        const step1 = document.querySelector(".cheque__step1");
        const step2 = document.querySelector(".cheque__step2");

        const button = currentForm.querySelector('button[type="submit"]');
        const uidField = currentForm.elements.uid;

        const uid = uidField.value;

        button.disabled = true;
        button.classList.add("site-btn--loading");

        const result = await getChequeInfo(uid);

        button.disabled = false;
        button.classList.remove("site-btn--loading");

        if (!result) {
            return;
        }

        step1.classList.add("d-none");
        step2.classList.remove("d-none");

        document.querySelector(".cheque-uid-before span").textContent = uid;

        document.querySelector(".companyName").textContent =
            result.companyName || "";

        document.querySelector(".branchName").textContent =
            result.branchName || "";

        document.querySelector(".branchAddress").textContent =
            result.branchAddress || "";

        document.querySelector(".companyINN").textContent =
            result.companyINN || "";

        document.querySelector(".terminalSN").textContent =
            result.terminalSN || "";

        document.querySelector(".cashier-user").textContent =
            result.user?.fullName
                ? `${result.user.fullName.lastName} ${result.user.fullName.firstName}`
                : "";

        document.querySelector(".shiftNo").textContent =
            result.shiftNo || "";

        document.querySelector(".numberInShift").textContent =
            result.additional?.numberInShift || "";

        document.querySelector(".receiptDateTime").textContent =
            result.receiptDateTime
                ? result.receiptDateTime.substring(0, 10)
                : "";

        document.querySelector(".receiptTypeStatus").textContent =
            result.status?.nameRu || "";

        if (result.receiptDetails?.length) {
            const chequeList = document.createElement("div");

            result.receiptDetails.forEach((item, index) => {
                const itemElement = document.createElement("div");

                itemElement.className = "cheque-products-list__item";

                itemElement.innerHTML = `
                <div class="cheque-products-list__item__index">
                    ${index + 1}.
                </div>

                <div class="cheque-products-list__item__content">
                    <div class="cheque-products-list__item__name">
                        ${item.productName}
                    </div>

                    <div class="rowQuantity">
                        <span>
                            ${siteScripts.helpers.formatWeight(item.qty, true)}
                            ${item.unitName}
                            х
                            ${siteScripts.helpers.formatPrice(item.price, true)}
                        </span>

                        <strong>
                            ${siteScripts.helpers.formatPrice(item.amount, true)}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.discount ? "" : "d-none"}">
                        <span>
                            Скидка: (${item.discountPercent}%):
                        </span>

                        <strong>
                            ${siteScripts.helpers.formatPrice(item.discount, true)}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.productBarcode ? "" : "d-none"}">
                        <span>Штрихкод:</span>

                        <strong>
                            ${item.productBarcode || ""}
                        </strong>
                    </div>

                    <div class="cheque__details__row">
                        <span>ИКПУ:</span>

                        <strong>
                            ${item.vatBarcode || ""}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.excise ? "" : "d-none"}">
                        <span>
                            Акциз -
                            ${siteScripts.helpers.formatPrice(item.exciseRate, true)}
                            UZS
                        </span>

                        <strong>
                            ${siteScripts.helpers.formatPrice(item.excise, true)}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.ndsPercent !== null ? "" : "d-none"}">
                        <span>
                            в т.ч. НДС - ${item.ndsPercent}%
                        </span>

                        <strong>
                            ${siteScripts.helpers.formatPrice(item.excise, true)}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.marks?.length ? "" : "d-none"}">
                        <span>Маркировка:</span>

                        <strong>
                            ${item.marks?.length || 0}
                        </strong>
                    </div>

                    <div class="cheque__details__row ${item.committentTin ? "" : "d-none"}">
                        <span>ИНН Комитента:</span>

                        <strong>
                            ${item.committentTin || ""}
                        </strong>
                    </div>
                </div>
            `;

                chequeList.append(itemElement);
            });

            document
                .querySelector(".cheque-products")
                .classList.remove("d-none");

            document
                .querySelector(".cheque-products-list")
                .append(chequeList);
        }

        document.querySelector(".receiptDetailsLength").textContent =
            result.receiptDetails?.length || 0;

        const totalCostWithDiscount =
            result.totalCost - (result.payments?.DISCOUNT || 0);

        if (result.payments?.DISCOUNT) {
            document
                .querySelector(".paymentsDiscountWrap")
                .classList.remove("d-none");

            document.querySelector(".totalCost").textContent =
                siteScripts.helpers.formatPrice(result.totalCost, true);

            document.querySelector(".paymentsDiscount").textContent =
                siteScripts.helpers.formatPrice(
                    result.payments.DISCOUNT,
                    true
                );

            document.querySelector(".totalCostWithDiscount").textContent =
                siteScripts.helpers.formatPrice(
                    totalCostWithDiscount,
                    true
                );
        } else {
            document
                .querySelector(".totalCostWithDiscountWrap")
                .classList.remove("d-none");

            document.querySelector(".totalCostWithDiscount").textContent =
                siteScripts.helpers.formatPrice(
                    totalCostWithDiscount,
                    true
                );
        }

        document.querySelector(".paid-bl").textContent =
            siteScripts.helpers.formatPrice(result.totalPaid || 0, true);

        document.querySelector(".totalVatAmount").textContent =
            result.payments?.NDS
                ? siteScripts.helpers.formatPrice(
                    result.payments.NDS,
                    true
                )
                : "";

        document.querySelector(".receiptSeq").textContent =
            result.additional?.receiptSeq || "";

        document.querySelector(".uidField").textContent =
            result.uid || "";

        if (result.additional?.samModuleSerialNumber) {
            document
                .querySelector(".samModuleSerialNumberWrap")
                .classList.remove("d-none");

            document.querySelector(".samModuleSerialNumber").textContent =
                result.additional.samModuleSerialNumber;
        }
    });
});
